module.exports = __webpack_public_path__ + "static/customer-workflow-management@3x-9e11835e7a96088cab46433520ed9546.png";